<template>
  <v-chip
    label
    x-small
    :color="bgColor"
    :text-color="textColor"
    class="font-weight-bold px-2"
  >
    {{ params.value }}
  </v-chip>
</template>

<script>
const STATUS_COLORS = {
  created:   { bg: "orange lighten-4",    text: "orange darken-3" },
  active:    { bg: "blue lighten-4",      text: "blue darken-3" },
  completed: { bg: "green lighten-4",     text: "green darken-3" },
  pickup:    { bg: "teal lighten-4",      text: "teal darken-3" },
  drop:      { bg: "deep-orange lighten-4", text: "deep-orange darken-3" },
};

export default {
  computed: {
    colors() {
      const key = this.params.value?.toLowerCase();
      return STATUS_COLORS[key] || { bg: "grey lighten-3", text: "grey darken-2" };
    },
    bgColor() {
      return this.colors.bg;
    },
    textColor() {
      return this.colors.text;
    },
  },
};
</script>
